export const ActionTypes = {
  LOADING: "LOADING_USER_ACTIONS",
  ERROR: "ERROR_USER_ACTIONS",
  SUCCESS: "SUCCESS_USER_ACTIONS",
};
